import { DenunciaAviso, GET_MOTIVOS_DENUNCIA, POST_DENUNCIA_AVISO } from '../types/denuncia'

export const getMotivosDenuncia = () => {
  return {
    type: GET_MOTIVOS_DENUNCIA,
    payload: null,
  }
}

export const denunciarAviso = (payload: DenunciaAviso) => {
  return {
    type: POST_DENUNCIA_AVISO,
    payload,
  }
}
